<ng-template #drawerFooter>
    <div style="text-align: right;">
        <button nz-button (click)="drawerRef?.close()">Cancel</button>
        <button nz-button nzType="primary" style="margin-left: 10px;"
            (click)="(drawerRef?.getContentComponent()?.onSubmit?.())">Submit</button>
    </div>
</ng-template>


<nz-spin [nzSpinning]="loading" [nzTip]="loadingMsg">
<form [formGroup]="form" (ngSubmit)="onSubmit()" nz-form [nzLayout]="'vertical'">



    <nz-form-item>
        <nz-form-label nzRequired>Select Vendor</nz-form-label>
        <nz-form-control nzErrorTip="Please select a vendor">
            <nz-select nzPlaceHolder="Select a vendor" nzAllowClear nzShowSearch nzServerSearch formControlName="vendor"
                (nzOnSearch)="onSearch($event)" (ngModelChange)="onVendorChange($event)">
                @if (!isLoadingVendorSearch) {
                @for (o of vendorOptions; track o.id) {
                <nz-option [nzValue]="o.id" [nzLabel]="o.name"></nz-option>
                }
                } @else {
                <nz-option nzDisabled nzCustomContent>
                    <nz-icon nzType="loading" class="loading-icon" />
                    Loading Data...
                </nz-option>
                }
            </nz-select>


        </nz-form-control>
        <a style="display: block; margin-top: 4px;" (click)="openDrawer(drawerFooter)" href="javascript:void(0)">
            + Add New Vendor
        </a>
    </nz-form-item>

    <nz-form-item>
        <nz-form-label nzRequired>Select Request</nz-form-label>
        <nz-form-control nzErrorTip="Please select a request">
            <nz-select formControlName="quotation_request" nzPlaceHolder="Select a request" nzAllowClear>
                @for (o of quotationRequestOptions; track o.id) {
                <nz-option [nzValue]="o.id" [nzLabel]="formatIdToFourDigits(o.id) + ' - ' + o.request_title"></nz-option>
                }
            </nz-select>
        </nz-form-control>
    </nz-form-item>

    <nz-form-item>
        <nz-form-label>Secure Key</nz-form-label>
        <nz-form-control>
            <nz-input-group nzSearch [nzSuffix]="suffixButton">
                <input nz-input formControlName="access_token" placeholder="Secure Key will be generated" readonly />
            </nz-input-group>
        </nz-form-control>
    </nz-form-item>

    <ng-template #suffixButton>
        <button type="button"    nzSize="small" nzSearch (click)="generateSecureKey($event)"> <nz-icon
                nzType="reload" nzTheme="outline" /> Regenerate</button>
    </ng-template>

    <nz-form-item>
        <nz-form-control>
            <label nz-checkbox formControlName="send_mail" (ngModelChange)="onSendEmailChange($event)"
            [nzDisabled]="!vendorEmail">
                Send link over email
            </label>
        </nz-form-control>
    </nz-form-item>


    <div class="email-message">
        <nz-alert [nzType]="vendorEmail ? 'info' : 'error'" [nzMessage]="messageBox"
            *ngIf="form.get('send_mail')?.value" [nzDescription]="descriptionBox" nzShowIcon>
        </nz-alert>
        <ng-template #messageBox>
            <p>
                {{ vendorEmail ? 'A message will be included with the link.':'No email address has been added for this vendor.'}}
            </p>
        </ng-template>
        <ng-template #descriptionBox>
            <p *ngIf="vendorEmail">The link will be sent to: <strong>{{ vendorEmail || 'N/A' }}</strong></p>
            <p *ngIf="!vendorEmail">Please update the vendor's email on the vendor screen before proceeding. Emails cannot be sent without it.</p>
        </ng-template>
    </div>


    <div style="display: flex; justify-content: flex-end;">
        <button type="submit" nz-button nzType="primary" [disabled]="form.invalid">Submit</button>
    </div>
</form>
</nz-spin>